import { useAuth } from '@/lib/auth';
import { API_URL, ENABLE_GOOGLE_CONVERSION, SUPER_ADMIN_ROLE } from '@/config';
import { useContext, useEffect, useState } from 'react';
import { showNotification } from '@/utils/notificationUtils';
import './login.scss';
import LoginLogo from '@/assets/img/p-logo-r.svg';
import MicrosoftLogin from '@/assets/img/microsoft-login-icon.svg';
import GoogleLoginFrame from '@/assets/img/google-frame.svg';
import Banner1 from '@/assets/img/banner-1.png';
import Banner2 from '@/assets/img/banner-2.png';
import Banner3 from '@/assets/img/banner-3.png';
import Banner4 from '@/assets/img/banner-4.png';
import Banner5 from '@/assets/img/banner-5.png';
import Banner6 from '@/assets/img/banner-6.png';
import Banner7 from '@/assets/img/banner-7.png';

import Enjo from '@/assets/img/enjo.png';
import MIGU from '@/assets/img/migu.png';
import Schedule from '@/assets/img/schedule.png';
import Map from '@/assets/img/Map.png';
import Payment from '@/assets/img/payment.png';
import Communication from '@/assets/img/communication.png';
import { ReactComponent as LeftCarouselArrow } from '@/assets/img/carousel-left.svg';
import { ReactComponent as RightCarouselArrow } from '@/assets/img/carousel-right.svg';
import Carousel from 'react-bootstrap/Carousel';

import { useNavigate } from 'react-router-dom';
import { UserResponse } from '../types';
import { CarouselIndex } from './CarouselIndex';
import { EmailLoginForm } from './EmailLoginForm';
import storage from '@/utils/storage';
import { LoginHeader } from '@/components/Layout/LoginHeader';
import { useTranslation } from 'react-i18next';
let myWindow: any;

type LoginFormProps = {
  onSuccess: () => void;
};

export const LoginForm = ({ onSuccess }: LoginFormProps) => {
  const { login } = useAuth();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [index, setIndex] = useState<number>(0);
  const [emailLogin, setEmailLogin] = useState<boolean>(false);
  const carouseItems = [0, 1, 2, 3, 4, 5, 6];
  const handleSelect = (selectedIndex: number) => {
    if (selectedIndex == 6 && index === 5) {
      setIndex(0);
      return;
    }
    if (selectedIndex == 6 && index === 0) {
      setIndex(6);
      return;
    }
    setIndex(selectedIndex);
  };

  useEffect(() => {
    window.onmessage = (ev: any) => {
      if (ev.data && ev.data.profile) {
        const user: UserResponse = ev.data.profile;
        if (myWindow) {
          myWindow.close();
        }
        const windowRef: any = window;
        if (user.isFirstTimeSignup) {
          const urlParams = extractUrlParams();
          urlParams.promoCode && storage.setKey(`promoCode`, urlParams.promoCode);
          if (ENABLE_GOOGLE_CONVERSION === 'yes') {
            if (windowRef.gtag) {
              const options = { user_email: user.email, ...urlParams };
              windowRef.gtag('event', 'conversion', {
                send_to: 'AW-16550157434/TmK6CLnhwq8ZEPq43dM9',
              });
              windowRef.gtag('event', 'petsked_signup', {
                user_email: user.email,
                user_utm_campaign: options.utm_campaign,
                user_utm_source: options.utm_source,
                user_utm_medium: options.utm_medium,
                user_referrer: options.referrer,
              });
            }
            if (windowRef?.fbq) {
              console.log('pixels getting tracked for Signup ->');
              //windowRef?.fbq('track', 'Subscribe', { contents: [{ email: user.email, subscriptionType: user?.subscriptionDetails?.productName === 'Petsked Premium' ? 'Paid' : 'Free' }] });
              windowRef?.fbq('track', 'Signup', {
                email: user.email,
                subscriptionType:
                  user?.subscriptionDetails?.productName === 'Petsked Premium' ? 'Paid' : 'Free',
              });
            }
          }
        }

        onLoginSuccess(user);
      } else if (ev.data && ev.data.error && ev.data.error.message) {
        if (myWindow) {
          myWindow.close();
        }
        showNotification({
          type: 'error',
          title: ev.data.error.message,
        });
      }
    };
  }, []);

  const buildUrlWithParams = (baseUrl: any, params: any) => {
    const url = new URL(baseUrl);
    Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));
    return url.toString();
  };

  const extractUrlParams = (extend = false) => {
    const urlParams = new URLSearchParams(window.location.search);
    const params: any = {};
    urlParams.forEach((value, key) => {
      params[key] = value;
    });
    if (extend) {
      params.app_url = window.location.href;
      params.referrer_url = document.referrer;
    }
    return params;
  };

  const urlParams = extractUrlParams(true);
  const googleLoginUrl = buildUrlWithParams(`${API_URL}/auth/google`, urlParams);
  const microsoftLoginUrl = buildUrlWithParams(`${API_URL}/auth/microsoft`, urlParams);
  const goToPreviousSlide = () => {
    if (index > 0) {
      setIndex(index - 1);
    } else {
      setIndex(carouseItems.length - 1);
    }
  };
  const goToNextSlide = () => {
    if (index < carouseItems.length - 1) {
      setIndex(index + 1);
    } else {
      setIndex(0);
    }
  };

  const setUserDetailsOnLogin = (data: any) => {};

  const onLoginSuccess = (user: any) => {
    login({ userData: user });

    const subscriptionDetails = user?.subscriptionDetails;
    if (
      subscriptionDetails?.status === 'trialing' ||
      subscriptionDetails?.status === 'active' ||
      subscriptionDetails?.status === 'past_due'
    ) {
      if (user?.businessUserRole?.name === SUPER_ADMIN_ROLE) {
        navigate('/businesses');
      } else {
        navigate('/availability');
      }
    } else {
      if (
        subscriptionDetails.status === 'trialing' ||
        subscriptionDetails.status === 'active' ||
        subscriptionDetails?.status === 'past_due'
      ) {
        navigate('/availability');
      } else {
        navigate('/billing');
      }
    }
  };
  return (
    <div>
      {/* <LoginHeader /> */}
      <div className="p-login login-step-1">
        <div className="left-login">
          {emailLogin ? (
            <div className="login-block">
              <EmailLoginForm
                onBack={() => setEmailLogin(false)}
                onLoginSuccess={(data: any) => onLoginSuccess(data)}
              />
            </div>
          ) : (
            <div className="login-block">
              <div className="logo-outer-p">
                <img src={LoginLogo} className="logo-r" />
              </div>
              <div>
                <div className="top-text-title">
                  {t('A one-stop solution for all your')}{' '}
                  <span className="red-text-title">{t('Pet Grooming')}</span> {t('schedules')}
                </div>
                <div className="pet-text-desc">
                  {t('Hurry up, the pets are waiting for you. Let’s get started!')}
                </div>

                <div className="login-btn-outer-new-figma-full-size">
                  <button
                    type="button"
                    className={`google-btn-style`}
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      const width = 530;
                      const height = 762;
                      const left = window.screen.width / 2 - width / 2;
                      const top = window.screen.height / 2 - height / 2;
                      const windowFeatures = `toolbar=0, status=0, width=${width}, height=${height}, top=${top}, left=${left}`;
                      myWindow = window.open(googleLoginUrl, `Login with Google}`, windowFeatures);
                    }}
                  >
                    <span className="google-icon-css">
                      <img src={GoogleLoginFrame} />
                    </span>
                    <span>{`Sign-in with Google`}</span>
                  </button>
                </div>

                <div className="or-div">{t('OR')}</div>
                <div className="login-btn-outer-new-figma-full-size">
                  <button
                    type="button"
                    className={`microsoft-btn-style`}
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      const width = 530;
                      const height = 762;
                      const left = window.screen.width / 2 - width / 2;
                      const top = window.screen.height / 2 - height / 2;
                      const windowFeatures = `toolbar=0, status=0, width=${width}, height=${height}, top=${top}, left=${left}`;
                      myWindow = window.open(
                        microsoftLoginUrl,
                        `Login with Microsoft}`,
                        windowFeatures
                      );
                    }}
                  >
                    <span>
                      <img src={MicrosoftLogin} className="microsoft-icon-css" />
                    </span>
                    <span>Sign-in with Microsoft</span>
                  </button>
                </div>

                <div className="or-div">OR</div>
                <div className="login-btn-outer-new-figma-full-size">
                  <button
                    type="button"
                    className={`google-btn-style email-btn`}
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      setEmailLogin(true);
                    }}
                  >
                    <span>{/* <img src={MicrosoftLogin} className="microsoft-icon-css" /> */}</span>
                    <span>Sign-in with Email</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="right-testimonial">
          <Carousel indicators={false} interval={null} activeIndex={index} onSelect={handleSelect}>
            <Carousel.Item>
              <img className="banner-img" src={Banner7} />
              <Carousel.Caption className="black-friday">
                <p className="center">
                  {/* This is the sample text needs to be replaced by us. This is the sample text needs
                  to be replaced by us. */}
                </p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="banner-img" src={Banner1} />
              <Carousel.Caption>
                <div className="rating">
                  <img src={Enjo} />
                </div>
                <h3>
                  &quot;{t('Petsked streamlines tasks, enabling 2 to 3 more weekly bookings')}&quot;
                </h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="banner-img" src={Banner2} />
              <Carousel.Caption>
                <div className="rating">
                  <img src={MIGU} />
                </div>
                <h3>&quot;{t('Petsked has revolutionized my grooming business!')}&quot;</h3>
                <p></p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="banner-img" src={Banner3} />
              <Carousel.Caption>
                <div className="module">
                  <img src={Map} />
                  <span>{t('Scheduling')}</span>
                </div>
                <h3 className="center">{t('Easiest way to manage schedule and bookings')}</h3>
                <p className="center">
                  {t(
                    'Seamlessly schedule, reschedule, and manage all your customer appointments with ease, ensuring a stress-free experience for both pets and their owners.'
                  )}
                </p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="banner-img" src={Banner4} />
              <Carousel.Caption>
                <div className="module">
                  <img src={Schedule} />
                  <span>{t('Mobile Route')}</span>
                </div>
                <h3 className="center">{t('Multi-Location and mobile grooming built in')}</h3>
                <p></p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="banner-img" src={Banner5} />
              <Carousel.Caption>
                <div className="module">
                  <img src={Communication} />
                  <span>{t('Communication')}</span>
                </div>
                <h3 className="center">{t('Appointment follow ups & reminders')}</h3>
                <p></p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="banner-img" src={Banner6} />
              <Carousel.Caption>
                <div className="module">
                  <img src={Payment} />
                  <span>{t('Payment')}</span>
                </div>
                <h3 className="center">{t('Accept your payments anytime, anywhere')}</h3>
                <p></p>
              </Carousel.Caption>
            </Carousel.Item>

            <div className="action-bar">
              <div>
                <LeftCarouselArrow className="action-left" onClick={goToPreviousSlide} />
                <span className="indicators">
                  {carouseItems.map((ci) => (
                    <CarouselIndex
                      key={`carousel-index${ci}`}
                      displayLabel={`${index + 1}`}
                      isActive={index === ci}
                      total={'' + carouseItems.length}
                    />
                  ))}
                </span>
                <RightCarouselArrow className="action-right" onClick={goToNextSlide} />
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
